import { Injectable } from '@angular/core';

import { Http, QueryHandlerFor, Wrapper } from '@skylab-angular-shared/core';
import { PurchaseRegistryExportQuery, PurchaseRegistryExportQueryHandlerBase } from '@skylab-shared/business';

@Injectable({ providedIn: 'root'})
@QueryHandlerFor(PurchaseRegistryExportQuery)
@Wrapper(PurchaseRegistryExportQueryHandlerBase)
export class PurchaseRegistryExportQueryHandler {
    public constructor(
        http: Http
    ) { }
}
